export default __webpack_public_path__ + "static/media/close_black.4e36df5c.svg";